

import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductUnion = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 5.89474C2 4.29602 3.37438 3 5.06977 3H22.9302C24.6256 3 26 4.29602 26 5.89474V10.1053C26 11.704 24.6256 13 22.9302 13H5.06977C3.37438 13 2 11.704 2 10.1053V5.89474ZM9 8C9 8.82843 8.32843 9.5 7.5 9.5C6.67157 9.5 6 8.82843 6 8C6 7.17157 6.67157 6.5 7.5 6.5C8.32843 6.5 9 7.17157 9 8Z" fill="#C72037"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2 17.8947C2 16.296 3.37438 15 5.06977 15H22.9302C24.6256 15 26 16.296 26 17.8947V22.1053C26 23.704 24.6256 25 22.9302 25H5.06977C3.37438 25 2 23.704 2 22.1053V17.8947ZM9 20C9 20.8284 8.32843 21.5 7.5 21.5C6.67157 21.5 6 20.8284 6 20C6 19.1716 6.67157 18.5 7.5 18.5C8.32843 18.5 9 19.1716 9 20Z" fill="#C72037"/>
    </SvgIcon>
  );
}

export default ProductUnion;